import { useState } from 'react'
import { publishEvent, getAttributeValue } from '../../utils'
import { OBJECT_VIEW_STYLE, ATTRIBUTE_NAME } from '../../constants'
import { Button } from 'reactstrap'

export default function AppObjectViewButton(props) {
  console.log('AppObjectViewButton rendered', props)

  const { objectId } = props
  const tabStyle = getAttributeValue(ATTRIBUTE_NAME.tabStyle)
  const [viewStyle, setViewStyle] = useState(tabStyle ? tabStyle : OBJECT_VIEW_STYLE.tab)

  function viewButtonClicked() {
    console.log('AppObjectViewButton.viewButtonClicked')
    const newViewStyle = viewStyle === OBJECT_VIEW_STYLE.card ? OBJECT_VIEW_STYLE.tab : OBJECT_VIEW_STYLE.card
    setViewStyle(newViewStyle)
    publishEvent(`TOGGLE VIEW STYLE ${objectId}`, null, 'AppObjectViewButton.viewButtonClicked')
  }

  const buttonText = viewStyle === OBJECT_VIEW_STYLE.card ? 'Tab View' : 'Card View'

  return (
    <Button data-cy='app-object-view-button' className="btn-sm" color="secondary" style={{ marginLeft: '10px', marginBottom: '10px'}} onClick={viewButtonClicked}>{buttonText}</Button>
  )
}
